export default "__VITE_ASSET__CEkya88___ 800w";